<template>
  <aside class="bg-light">
    <div id="invitation-background" style="height: 539px;">
      <div class="grid grid--center">
        <div class="grid__cell col7-of-12 p-sm">
          <h1 class="fw-bold fs-xl">{{ data.headline }}</h1>
          <div class="bg-base p-sm mt-md theme-border-base content-steps">
            <h3 class="fs-md mb-xs">Next Steps</h3>
            <ol>
              <li class="fs-md pt-xs">{{ data.firstStep }}</li>
              <li class="fs-md pt-xs">
                {{ data.secondStep }}
              </li>
              <li class="fs-md pt-xs">{{ data.thirdStep }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  props: {
    data: Object,
  },
};
</script>
